export const META_STORE_REQUEST_TYPE = '.MetaStoreRequestMsg.metaStoreRequest';
export const META_STORE_RESPONSE_TYPE = '.MetaStoreResponseMsg.keyStoreResponse';
